import React from 'react'

const AvailablePositionsSection = () => {
  const positions = [
    {
      id: 1,
      title: 'Student Success',
      status: 'Intern',
      statusColor: 'text-blue-600 bg-blue-100',
      icon: '/img/career/Vector_9.svg',
      url: 'https://api.whatsapp.com/send/?phone=62811811628&text=Halo,%20saya%20ingin%20melamar%20posisi%20STUDENT%20SUCCESS&type=phone_number&app_absent=0',
    },
    {
      id: 2,
      title: 'Class Facilitator',
      status: 'Freelance',
      statusColor: 'text-green-600 bg-green-100',
      icon: '/img/career/Vector_9.svg',
      url: 'https://api.whatsapp.com/send/?phone=62811811628&text=Halo,%20saya%20ingin%20melamar%20posisi%20CLASS%20FACILITATOR&type=phone_number&app_absent=0',
    },
  ]

  const handleApply = (url: string) => {
    window.open(url, '_blank')
  }

  return (
    <section className="bg-yes-600 py-16 lg:py-24">
      <div className="container mx-auto px-4 lg:px-12">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <h2 className="mb-6 text-3xl font-bold text-white lg:text-5xl">
            Posisi Yang Tersedia
          </h2>

          <p className="mx-auto max-w-3xl text-lg leading-relaxed text-white lg:text-xl">
            Di YES, kami selalu berusaha menyediakan posisi yang terbaik untuk
            memulai karirmu dan meningkatkan skillmu.
          </p>
        </div>

        {/* Positions List */}
        <div className="mx-auto max-w-4xl space-y-6">
          {positions.map((position) => (
            <div
              key={position.id}
              className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md lg:p-8"
            >
              <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
                {/* Position Info */}
                <div className="flex flex-1 items-center gap-6">
                  {/* Icon */}
                  <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-xl bg-red-50 lg:h-20 lg:w-20">
                    <img
                      src={position.icon}
                      alt="Position icon"
                      className="h-8 w-8 lg:h-10 lg:w-10"
                    />
                  </div>

                  {/* Position Details */}
                  <div>
                    <h3 className="mb-2 text-xl font-semibold text-gray-800 lg:text-2xl">
                      {position.title}
                    </h3>

                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-600">
                        Status :
                      </span>
                      <span
                        className={`rounded-full px-3 py-1 text-sm font-medium ${position.statusColor}`}
                      >
                        {position.status}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Apply Button */}
                <button
                  onClick={() => handleApply(position.url)}
                  className="min-w-[120px] self-stretch rounded-lg bg-red-600 px-8 py-3 font-semibold text-white transition-colors duration-300 hover:bg-red-700 sm:self-auto"
                >
                  Apply
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional CTA Section */}
        <div className="mt-12 text-center">
          <p className="mb-6 text-white">
            Tidak menemukan posisi yang cocok? Kirimkan CV Anda untuk peluang
            masa depan.
          </p>

          <button
            onClick={() => handleApply('mailto:hello@yes.co.id')}
            className="rounded-lg bg-gray-800 px-8 py-3 font-semibold text-white transition-colors duration-300 hover:bg-gray-900"
          >
            Kirim CV
          </button>
        </div>
      </div>
    </section>
  )
}

export default AvailablePositionsSection
